export const enum SearchRequestStatus {
  Initial,
  Loading,
  Loaded,
  Failed,
}
